import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils.js';

const updateHeaderBar = (data) => {
    if (document.querySelector('.header-bar')) {
        document.querySelector('.treatment-provider').innerText = data.firstName + ' ' + data.lastName;
        document.querySelector('.hcp-type').innerText = global.HCP_TYPE_LIST[data.hcpType];
        document.querySelector('.npi-number span').innerText = data.npi;
        document.querySelector('.dea-number span').innerText = Object.values(data.deaState).flat().join(', ');

        PL_utils.removeClass('hidden', document.querySelector('.treatment-provider'));
        PL_utils.removeClass('hidden', document.querySelector('.hcp-type'));
        PL_utils.removeClass('hidden', document.querySelector('.npi-number'));
        PL_utils.removeClass('hidden', document.querySelector('.dea-number'));
        PL_utils.addClass('hidden', document.querySelector('#user-details-loading'));
    }
}

export default () => {
    if (global.IS_ED_MODE) {
        return
    }

    const session = utils.getSession();
    const csrfToken = utils.getCookie('csrfToken');
    const headerBar = document.querySelector('.header-bar');

    if (session && headerBar) {
        PL_utils.removeClass('hidden', headerBar);
        updateHeaderBar(session);
    }

    if (csrfToken) {
        headerBar && PL_utils.removeClass('hidden', headerBar);
        document.querySelector('.logo-link').href = '/listings';
        $.ajax(global.API_ENDPOINT() + '/user/get-details', {
            dataType: 'json',
            method: 'GET',
            headers: {
                'csrf-token': csrfToken,
            },
            xhrFields: {
                withCredentials: true,
            }
        })
        .done(function (resp) {
            if (resp.success) {
                utils.setSession(resp.data);
                updateHeaderBar(resp.data);

                if (location.pathname == '/') {
                    // Already logged in
                    window.location.href = '/listings';
                }
            } else {
                utils.logoutSession();
                if (global.AUTHENTICATED_PAGES.indexOf(location.pathname) > -1) {
                    window.location.href = '/';
                } else {
                    window.location.reload(true);
                }
            }
        })
        .fail(function (err) {
            console.error(JSON.stringify(err));
        })
    } else {
        utils.logoutSession();
        if (global.AUTHENTICATED_PAGES.indexOf(location.pathname) > -1) {
            window.location.href = '/';
        }
    }
}

